// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__mmbmO","info":"Panel_info__nXqpZ","btns":"Panel_btns__2obf-","button":"Panel_button__dA6PP","input":"Panel_input__MLeqg"};